export class AssignmentChartsModel {
    studentStatusChart: any = {};
}